export default __webpack_public_path__ + "static/media/ic_antigua_and_barbuda.1ea3ac90.svg";